import { useMemo } from 'react';

import SFilter from '@/features/StructuredFilter/class/SFilter';
import { useStructuredStorageFilterQuery } from '@/features/StructuredFilter/hooks/useStructuredFilterQuery';
import useWorkspaceStorage from '@/hooks/pure/useWorkspaceStorage';
import { createStorageParser } from '@/utils/storage';

import { DEFAULT_SIGNAL_DATE_SELECTION } from '../lib';
import {
  type SignalDateSelection,
  storedSignalDateSelectionSchema,
} from '../model';

export type GlobalIssueState = {
  filterQueryFormats: StructuredFilterQueryFormatT[];
  onFilterSetChange: (
    filterQueryFormats: StructuredFilterQueryFormatT[],
  ) => void;
  clearFilter: () => void;
  dateSelection: SignalDateSelection;
  setDateSelection: (dateSelection: SignalDateSelection) => void;
  compositedFilter: StructuredFilter;
};

export const useGlobalSignalIssueState = (): GlobalIssueState => {
  const { filterQueryFormats, onFilterSetChange, clearFilter } =
    useStructuredStorageFilterQuery('signals-dynamic-filter');

  const [dateSelection, setDateSelection] =
    useWorkspaceStorage<SignalDateSelection>(
      'signals-date-preset',
      DEFAULT_SIGNAL_DATE_SELECTION,
      {
        parser: createStorageParser(
          storedSignalDateSelectionSchema,
          DEFAULT_SIGNAL_DATE_SELECTION,
        ),
      },
    );

  const compositedFilter = useMemo(() => {
    const sFilter = new SFilter();
    sFilter.addFilterQueryFormats(filterQueryFormats);
    return sFilter.get() || {};
  }, [filterQueryFormats]);

  return {
    filterQueryFormats,
    onFilterSetChange,
    clearFilter,
    dateSelection,
    setDateSelection,
    compositedFilter,
  };
};
